export default __webpack_public_path__ + "static/media/in-the-end.a45c90fc.jpg";